


























































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeProjet from '@/stores/modules/projet';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import Checked from '@/components/Checked.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import {
	DxColumn,
	DxDataGrid,
	DxEditing,
	DxFilterRow,
	DxGrouping,
	DxGroupItem,
	DxGroupPanel,
	DxHeaderFilter,
	DxLookup,
	DxMasterDetail, DxPager, DxPaging,
	DxRangeRule,
	DxRequiredRule,
	DxScrolling,
	DxStringLengthRule,
	DxSummary,
	DxTotalItem, DxValueFormat
} from "devextreme-vue/data-grid";
import {DxCheckBox} from "devextreme-vue/check-box";
import {Projet, Token} from "@/models";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {Stored} from "vue-stored-prop-decorator";
import storeToken from "@/stores/modules/token";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudProjetEditDialog from "@/components/Crud/Projet/EditDialog.vue";

@Component({
	components: {
		CrudList, TableHead, TableCell,
		DxDataGrid, DxColumn, DxEditing,
		DxFilterRow, DxHeaderFilter, DxGroupPanel,
		DxGrouping, DxScrolling, DxSummary,
		DxLookup, DxTotalItem, DxGroupItem,
		DxMasterDetail, DxStringLengthRule, DxRangeRule,
		DxRequiredRule, DxValueFormat, DxPaging,
		DxPager, DxCheckBox, Checked,
		CrudDeleteDialog, CrudProjetEditDialog
	}
})
export default class CrudProjetList extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeToken) token!: Token;

	private storeProjet = storeProjet;

	private url = process.env.VUE_APP_BACK_BASE_URL + '/api/projets'

	private editProjet: Projet = null;
	private deletedProjet: Projet = null;
	private dataGrid;

	private dataSource = createStore({
		key: 'id',
		loadUrl: `${this.url}/dxDataGrid`,
		onBeforeSend: (method, ajaxOptions) => {
			ajaxOptions.xhrFields = { withCredentials: true };
			ajaxOptions.headers = {
				'Authorization': 'BEARER ' + this.token.id
			}
		},
	});

	public refresh() {
		this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		this.dataGrid.instance.refresh()
	}
}
